import TickerClarosports from "../components/tickerClarosports/tickerClarosports";

export default function TickerClarosportsPage() {

  return (
    <div className="page-ticker-cs">
      <TickerClarosports />
    </div>
  );
}